var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isFullCircle)?_c('circle',{attrs:{"cx":_vm.center,"cy":_vm.center,"r":_vm.radius,"fill":"none"}}):_c('path',{attrs:{"d":_vm.pathData,"fill":"none"}})}
var staticRenderFns = []

export { render, staticRenderFns }